import React, { useState, useEffect } from "react";
import { Clock } from "lucide-react";

export const DualClock = ({ userTimezone = "UTC", clientTimezone = null, clientName = null }) => {
  const [userTime, setUserTime] = useState("");
  const [clientTime, setClientTime] = useState("");

  useEffect(() => {
    const updateClocks = () => {
      try {
        // Format current time in user's timezone
        const userFormatter = new Intl.DateTimeFormat("en-US", {
          timeZone: userTimezone,
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
        setUserTime(userFormatter.format(new Date()));

        // Format current time in client's timezone if provided
        if (clientTimezone) {
          const clientFormatter = new Intl.DateTimeFormat("en-US", {
            timeZone: clientTimezone,
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          });
          setClientTime(clientFormatter.format(new Date()));
        }
      } catch (e) {
        console.error("Clock format error:", e);
      }
    };

    updateClocks();
    const interval = setInterval(updateClocks, 1000);
    return () => clearInterval(interval);
  }, [userTimezone, clientTimezone]);

  return (
    <div className="flex items-center gap-4 px-4 py-2 bg-slate-100 dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700">
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4 text-slate-600 dark:text-slate-400" />
        <div className="text-xs">
          <p className="text-slate-500 dark:text-slate-400 font-medium">You ({userTimezone})</p>
          <p className="font-mono text-sm font-semibold text-slate-900 dark:text-slate-100">
            {userTime}
          </p>
        </div>
      </div>

      {clientTimezone && (
        <>
          <div className="h-6 w-px bg-slate-300 dark:bg-slate-600" />
          <div className="text-xs">
            <p className="text-slate-500 dark:text-slate-400 font-medium">
              Client {clientName ? `(${clientName})` : ""} ({clientTimezone})
            </p>
            <p className="font-mono text-sm font-semibold text-slate-900 dark:text-slate-100">
              {clientTime}
            </p>
          </div>
        </>
      )}
    </div>
  );
};
